import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Observable} from 'rxjs';
import {AppState} from '../store';
import {select, Store} from '@ngrx/store';
import {selectTenantInfo} from '../store/selectors';
import {filter, map} from 'rxjs/operators';

/**
 *
 * If the home page is activated, then display it otherwise redirect to the courses page.
 *
 */


@Injectable()
export class CheckIfHomePageActiveGuard  {

  constructor(
    private store: Store<AppState>,
    private router: Router) {

  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this.store.pipe(
      select(selectTenantInfo),
      filter(tenant => !!tenant),
      map(tenant => {
        if (tenant.homePageOn) {
          return true;
        } else {
          return this.router.parseUrl('/courses');
        }
      })
    );
  }


}
